// Znak PateX Group "Pęd" (pochylone P z pasami prędkości). Jeden komponent używany na ekranie startowym, u kierowcy i w panelu admina.
import React from "react";

let __pm = 0;
const P_PATH = "M92 62H104C125 62 139 74 139 92C139 110 125 122 104 122H92Z M92 80V104H103C112 104 119 99 119 92C119 85 112 80 103 80Z";
const P_FULL = "M72 142V62H104C125 62 139 74 139 92C139 110 125 122 104 122H92V142Z M92 80V104H103C112 104 119 99 119 92C119 85 112 80 103 80Z";

export function PatexMark({ size = 48, tile = true, anim = false, glow, className = "" }) {
  const id = React.useMemo(() => "pm" + ++__pm, []);
  const g = glow === undefined ? size >= 56 : glow;
  return (
    <svg className={"pm " + (anim ? "pm-anim " : "") + className} width={size} height={size} viewBox="0 0 200 200" aria-hidden="true" focusable="false">
      <defs>
        <radialGradient id={id + "b"} cx=".3" cy=".25" r=".95">
          <stop offset="0" stopColor="#4a1428" />
          <stop offset=".55" stopColor="#2a0d1a" />
          <stop offset="1" stopColor="#140509" />
        </radialGradient>
        <linearGradient id={id + "g"} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#fff0bf" />
          <stop offset=".48" stopColor="#ffb82e" />
          <stop offset="1" stopColor="#ff7a1a" />
        </linearGradient>
        <linearGradient id={id + "t"} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#ffb82e" stopOpacity="0" />
          <stop offset="1" stopColor="#ffb82e" />
        </linearGradient>
        {g && (
          <filter id={id + "f"} x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="7" />
          </filter>
        )}
      </defs>
      {tile && (
        <>
          <rect x="8" y="8" width="184" height="184" rx="46" fill={"url(#" + id + "b)"} />
          <rect x="8.5" y="8.5" width="183" height="183" rx="45.5" fill="none" stroke="#fff" strokeOpacity=".13" />
        </>
      )}
      <g transform="translate(100 100) skewX(-11) translate(-100 -100)">
        {g && <path className="pm-gl" d={P_FULL} fill="#ffb82e" fillRule="evenodd" opacity=".45" filter={"url(#" + id + "f)"} />}
        <g fill={"url(#" + id + "g)"}>
          <path d={P_PATH} fillRule="evenodd" />
          <rect x="72" y="62" width="19" height="17" rx="3" />
          <rect x="72" y="84" width="19" height="17" rx="3" />
          <rect x="72" y="106" width="19" height="17" rx="3" />
          <rect x="72" y="128" width="19" height="14" rx="3" />
        </g>
        <g fill={"url(#" + id + "t)"}>
          <rect className="pm-tr pm-t1" x="22" y="68" width="46" height="5" rx="2.5" />
          <rect className="pm-tr pm-t2" x="34" y="90" width="34" height="5" rx="2.5" />
          <rect className="pm-tr pm-t3" x="14" y="112" width="54" height="5" rx="2.5" />
          <rect className="pm-tr pm-t4" x="40" y="134" width="28" height="5" rx="2.5" />
        </g>
      </g>
    </svg>
  );
}

// Ten sam znak jako tekst SVG — do dokumentów PDF/wydruków generowanych jako HTML (bez Reacta).
export function patexMarkSvg(size = 32) {
  return (
    '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 200 200" style="vertical-align:middle;margin-right:10px">' +
    '<defs><radialGradient id="pdb" cx=".3" cy=".25" r=".95"><stop offset="0" stop-color="#4a1428"/><stop offset=".55" stop-color="#2a0d1a"/><stop offset="1" stop-color="#140509"/></radialGradient>' +
    '<linearGradient id="pdg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff0bf"/><stop offset=".48" stop-color="#ffb82e"/><stop offset="1" stop-color="#ff7a1a"/></linearGradient>' +
    '<linearGradient id="pdt" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#ffb82e" stop-opacity="0"/><stop offset="1" stop-color="#ffb82e"/></linearGradient></defs>' +
    '<rect x="8" y="8" width="184" height="184" rx="46" fill="url(#pdb)"/>' +
    '<g transform="translate(100 100) skewX(-11) translate(-100 -100)"><g fill="url(#pdg)"><path d="' + P_PATH + '" fill-rule="evenodd"/>' +
    '<rect x="72" y="62" width="19" height="17" rx="3"/><rect x="72" y="84" width="19" height="17" rx="3"/><rect x="72" y="106" width="19" height="17" rx="3"/><rect x="72" y="128" width="19" height="14" rx="3"/></g>' +
    '<g fill="url(#pdt)"><rect x="22" y="68" width="46" height="5" rx="2.5"/><rect x="34" y="90" width="34" height="5" rx="2.5"/><rect x="14" y="112" width="54" height="5" rx="2.5"/><rect x="40" y="134" width="28" height="5" rx="2.5"/></g></g></svg>'
  );
}
